import React, { useEffect, useState } from "react";
import Marquee from "react-marquee-slider";
import Logo1 from "../../assets/logos/CNW.png";
import Logo2 from "../../assets/logos/DLOGO_BarwonFoods.png";
import Logo3 from "../../assets/logos/gtandb-logo-white.png";
import Logo4 from "../../assets/logos/trade_gear.webp";
import Logo5 from "../../assets/logos/plumber_co-op.png";
import Logo6 from "../../assets/logos/MotifLogo.png";
import Logo7 from "../../assets/logos/urban_outdoor.png";
import Logo8 from "../../assets/logos/samios.png";
import Logo9 from "../../assets/logos/skinners.png";
import Logo10 from "../../assets/logos/walkers.png";
import Logo11 from "../../assets/logos/womers.png";
import Logo12 from "../../assets/logos/woodevo_wallington.jpg";
import Logo13 from "../../assets/logos/tait.png";
import Logo14 from "../../assets/logos/footer-logo-roberts-designs.png";

const Brands = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [velocity, setVelocity] = useState(8);
    const icons = [
        Logo1,
        Logo2,
        Logo3,
        Logo4,
        Logo5,
        Logo6,
        Logo7,
        Logo8,
        Logo9,
        Logo10,
        Logo11,
        Logo12,
        Logo13,
        Logo14,
    ];



    // Adjust velocity based on screen size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setVelocity(3);
            } else {
                setVelocity(8);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section className="overflow-hidden py-5 md:py-20">
            <div
                className="w-full"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Marquee Slider */}
                <Marquee
                    velocity={isHovered ? 0 : velocity}
                    minScale={0.7}
                    resetAfterTries={200}
                    direction="rtl"
                >
                    {/* Mapping over the icons */}
                    {icons.concat(icons).map((icon, index) => (
                        <img
                            key={index}
                            src={icon}
                            alt="banner-icon"
                            className="max-h-10 md:max-h-14 w-auto my-0 md:mx-10 mx-7 object-contain"
                            loading="lazy"
                        />
                    ))}
                </Marquee>
            </div>
        </section>
    );
};

export default Brands;